import { AfterViewInit, Directive, ElementRef, inject, Input, OnDestroy } from '@angular/core';
import { ComponentVisibilityService } from '../services';

/**
 * Directive to track the visibility of a component in the viewport.
 */
@Directive({
  standalone: true,
  selector: '[lxVisibility]',
})
export class VisibilityDirective implements AfterViewInit, OnDestroy {
  @Input('lxVisibility') componentId: string | undefined;

  private observer: IntersectionObserver | undefined;

  private readonly componentVisibilityService = inject(ComponentVisibilityService);
  private readonly elementRef = inject(ElementRef);

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.componentVisibilityService.setVisibility(this.componentId, entry.isIntersecting);
      },
      { threshold: 0.1 },
    );

    this.observer.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
